module.exports = __webpack_public_path__ + "img/scholarship4.ea91ab54.png";